<template>
  <div>
    <pdp-skeleton v-if="!mediaGalleryHorizontalScroll?.enabled" />
    <div v-else class="lg:mb-10 lg:flex lg:items-start">
      <div class="hidden lg:flex lg:grow lg:gap-1 lg:overflow-hidden">
        <div
          v-for="i in 6"
          :key="i"
          class="shrink-0 skeleton"
          :style="{
            'aspect-ratio': width / height,
            'height': `max(44rem, calc(100dvh - ${pxToRem(header.height.full + 24)}))`,
          }"
        />
      </div>
      <div
        class="skeleton lg:hidden"
        :style="{ 'aspect-ratio': width / height }"
      />
      <div
        v-style="{ w: { lg: '30rem' }, top: { lg: '9rem' } }"
        class="f-col gap-y-2 px-4 pb-4 lg:sticky lg:shrink-0 lg:px-6 lg:pt-4"
      >
        <div class="<lg:hidden space-y-2">
          <div class="mt-2 h-7 w-full skeleton" />
          <div class="h-4 w-75 skeleton" />
          <div class="h-4 w-30 skeleton" />
          <div class="h-4 w-64 skeleton" />
        </div>
        <div class="my-4 lg:mb-6">
          <div class="flex wrap -ml-2">
            <div
              v-for="i in 5"
              :key="i"
              class="m-2 skeleton"
              :style="{ width: '1.5rem', height: '1.5rem' }"
            />
          </div>
          <div class="mt-2 w-full flex between">
            <div class="h-4 w-24 skeleton" />
            <div class="h-4 w-24 skeleton" />
          </div>
        </div>
        <div class="lg:hidden space-y-2">
          <div class="mt-2 h-7 w-full skeleton" />
          <div class="h-4 w-75 skeleton" />
          <div class="h-4 w-30 skeleton" />
          <div class="h-4 w-64 skeleton" />
        </div>
        <div class="w-full flex gap-2">
          <div class="h-13 shrink skeleton" style="min-width: 7.5rem" />
          <div class="h-13 grow skeleton" />
        </div>
        <div class="mt-2 w-full flex between">
          <div class="h-4 w-30 skeleton" />
          <div class="h-4 w-64 skeleton" />
        </div>
        <div class="mt-4 b-t b-grey-80" />
        <div class="mt-2 w-full flex gap-2">
          <div class="h-6 w-24 skeleton" />
          <div class="h-6 w-24 skeleton" />
          <div class="h-6 w-24 skeleton" />
          <div class="h-6 w-24 skeleton" />
          <div class="h-6 w-24 skeleton" />
        </div>
        <div class="mt-2 w-full flex gap-2 between">
          <div class="h-24 w-30 skeleton" />
          <div class="h-24 w-30 skeleton" />
          <div class="h-24 w-30 skeleton" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import PdpSkeleton from '#brand/components/pdp/Skeleton.vue'

const mediaGalleryHorizontalScroll = useOptimizelyFlag('media_gallery_horizontal_scroll')
const { width, height } = useAppConfig().pages.pdp.gallery.presets.src

const header = useHeaderStore()
</script>
